<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card" *ngIf="_utilService.isDesktop || _utilService.isTablet">
      <div class="card-header">
        <div class="d-flex">
          <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control my-width" [(ngModel)]="searchKeyword" (ngModelChange)="filterCapabilities()" />
          <div class="ml-1 my-width">
            <ng-select
              id="figure"
              [(ngModel)]="filter_role"
              [closeOnSelect]="true"
              [openOnEnter]="true"
              [virtualScroll]="true"
              [clearable]="filter_role != -1"
              (ngModelChange)="filterCapabilities()"
              (clear)="filter_role = -1; filterCapabilities()"
            >
              <ng-option [value]="-1">
                <span class="font-small-4 font-weight-normal">{{ "ALL_ROLES" | translate }}</span>
              </ng-option>
              <ng-option [value]="-2">
                <span class="font-small-4 font-weight-normal">{{ "NO_ROLES" | translate }}</span>
              </ng-option>
              <ng-option *ngFor="let role of roles" [value]="role.id">
                <span class="font-small-4 font-weight-normal">{{ role.name }}</span>
              </ng-option>
            </ng-select>
          </div>
        </div>
        <div>
          <button type="button" class="btn btn-primary" (click)="save()" [disabled]="buttonIsDisabled()" *ngIf="_authenticationService.hasCapability('assign_capability')">{{ "SAVE" | translate }}</button>
          <button type="button" class="btn btn-outline-primary ml-1" (click)="resetFilterRole()" *ngIf="showRole != 0">{{ "REMOVE_ROLES_FILTER" | translate }}</button>
        </div>
      </div>
      <div class="card-body px-0 pb-0" *ngIf="rolesToShow && filteredCapabilities">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="60"
          [rowHeight]="50"
          [footerHeight]="50"
          [limit]="15"
          [scrollbarV]="false"
          [scrollbarH]="true"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rows]="filteredCapabilities"
        >
          <ngx-datatable-column [name]="'CAPABILITY' | translate" prop="name" width="350">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.name }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            *ngFor="let role of rolesToShow"
            [name]="role.name"
            [sortable]="false"
            [width]="showRole == 0 ? roleColumnWidth[role.name] || 100 : 1000"
            [cellClass]="showRole == 0 ? 'justify-content-center' : ''"
            [headerClass]="showRole == 0 ? 'd-flex justify-content-center role-label cursor-pointer' : ''"
          >
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="w-100 d-block mx-auto custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" [checked]="row.role_ids.includes(role.id)" [id]="role.name + '-' + row.code" (click)="handlerClickCapability(row.id, role.id)" />
                <label class="custom-control-label" [for]="role.name + '-' + row.code"></label>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
    <div class="card" *ngIf="_utilService.isMobile">
      <h2 class="text-center p-3">{{ "PAGE_NOT_AVAILABLE_FROM_MOBILE" | translate }}</h2>
    </div>
  </div>
</div>
